(() => {
  function instantiateRelatedProductSwiper() {
    const relatedProductsSwiper = new Swiper(".js-related-products__swiper", {
      watchOverflow: true,
      slidesPerView: 1.6,
      spaceBetween: 24,
      pagination: {
        el: ".js-related-products__swiper-pagination",
        type: "progressbar",
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
        1536: {
          slidesPerView: 5,
          spaceBetween: 36,
        },
      },
    });
  }

  const relatedProductsObserver = new MutationObserver(
    (mutations, observer) => {
      instantiateRelatedProductSwiper();
      observer.disconnect();
    }
  );

  relatedProductsObserver.observe(
    document.querySelector(".js-related-products-observe"),
    {
      childList: true,
      subtree: true,
    }
  );
})();
